exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, "\n.modal-container[data-v-13a13c7a] {\n    max-width: 600px;\n    min-height: 330px;\n}\n", "", {"version":3,"sources":["/codebuild/output/src663559002/src/slink-frontend/src/components/ModalAddRemPack.vue"],"names":[],"mappings":";AACA;IACI,iBAAiB;IACjB,kBAAkB;CACrB","file":"ModalAddRemPack.vue","sourcesContent":["\n.modal-container[data-v-13a13c7a] {\n    max-width: 600px;\n    min-height: 330px;\n}\n"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"sourceMap":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-13a13c7a","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/ModalAddRemPack.vue
// module id = L2jf
// module chunks = 1